<div class="rek-static-page kt-content">
  <div class="row">
    <div class="col-12">
      <div class="rek-static-page__title-container kt-portlet kt-portlet-shadow text-center"
           [class.rek-static-page__title-container--normal-margin]="alerts.length">
        <div class="kt-portlet__body">
          <p
            class="rek-static-page__title rek-static-page-color no-margin-bottom">{{ 'HOME.CONTACT.PAGE-TITLE' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngFor="let alert of alerts">
    <rek-alert-framed [icon]="'flaticon-exclamation-1'" [text]="alert.text"
                      [additionalClasses]="'alert-danger'"></rek-alert-framed>
  </ng-container>

  <div class="rek-static-page__content row mt-5 mt-lg-0">
    <div class="col-lg-4">
      <rek-framed-portlet title="{{ 'SHARED.LOCALIZATIONS.WARSAW' | translate }}">
        <div class="inner-p-no-margin-bottom">
          <p><b>{{ 'HOME.CONTACT.ENROLLMENT-DEPARTMENT' | translate }}</b></p>
          <p>{{ 'SHARED.PJAIT-NAME' | translate }}</p>
          <p>{{ 'HOME.CONTACT.STREET-WARSAW' | translate }}</p>
          <p>02-008 {{ 'SHARED.LOCALIZATIONS.WARSAW' | translate }}</p>
          <br/>
          <p>{{ 'HOME.CONTACT.ROOM' | translate }} 15</p>
          <br/>
          <p>(+48) 22 58 44 590 ({{ 'HOME.CONTACT.PL-EN-RU-UA' | translate }})</p>
          <br/>
          <p>E-mail: <a href="mailto:rekrutacja@pja.edu.pl" target="_blank">rekrutacja@pja.edu.pl</a></p>
          <br/>
          <p>{{ 'HOME.CONTACT.OTHER-INFO' | translate }}:
            <a
              href="{{isPolishSelected ? 'https://pja.edu.pl/dla-kandydata/#rekrutacja':'https://pja.edu.pl/en/dla-kandydata/'}}"
              target="_blank">{{ 'HOME.RULES-WARSAW.PAGE-TITLE' | translate }}</a>
          </p>
        </div>
        <br/>
        <div class="inner-p-no-margin-bottom">
          <p><b>{{ 'HOME.CONTACT.POSTGRADUATE-EDUCATION-CENTER' | translate }}</b></p>
          <p>{{ 'SHARED.PJAIT-NAME' | translate }}</p>
          <p>{{ 'HOME.CONTACT.STREET-WARSAW' | translate }}</p>
          <p>02-008 {{ 'SHARED.LOCALIZATIONS.WARSAW' | translate }}</p>
          <br/>
          <p>{{ 'HOME.CONTACT.ROOM' | translate }} 17B</p>
          <br/>
          <p>(+48) 22 58 44 597 ({{ 'HOME.CONTACT.PL-EN' | translate }})</p>
          <br/>
          <p>E-mail: <a href="mailto:podyplomowe@pja.edu.pl" target="_blank">podyplomowe@pja.edu.pl</a></p>
        </div>
      </rek-framed-portlet>
    </div>

    <div class="col-lg-4">
      <rek-framed-portlet title="{{ 'SHARED.LOCALIZATIONS.GDANSK' | translate }}">
        <div class="inner-p-no-margin-bottom">
          <p><a href="https://gdansk.pja.edu.pl/pl/kontakt#dziekanat"
                target="_blank">{{ 'HOME.CONTACT.DEANS-OFFICE' | translate }}</a></p>
          <p>{{ 'SHARED.PJAIT-NAME' | translate }}</p>
          <p>{{ 'HOME.CONTACT.STREET-GDANSK' | translate }}</p>
          <p>80-894 {{ 'SHARED.LOCALIZATIONS.GDANSK' | translate }}</p>
          <br/>
          <p>(+48) 516 023 661</p>
          <br/>
          <br/>
          <p>E-mail: <a href="mailto:gdansk@pja.edu.pl" target="_blank">gdansk@pja.edu.pl</a></p>
          <br/>
          <p>{{ 'HOME.CONTACT.OTHER-INFO' | translate }}: <a href="https://gdansk.pja.edu.pl/dla-kandydata"
                                                             target="_blank">{{ 'HOME.RULES-GDANSK.PAGE-TITLE' | translate }}</a>
          </p>
        </div>
      </rek-framed-portlet>
    </div>
  </div>
</div>
